import './../../scss/app.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import MediaLabStory from './components/MediaLabStory.jsx';
import storyData from './../data/story-data';


/**
 * Calls a function when the DOM is ready
 * @param {Function} callback - The function to call
 * @returns {undefined} undefined
 */
function domReady(callback) {
  const doc = document;
  const attach = 'addEventListener';

  if (doc[attach]) {
    doc[attach]('DOMContentLoaded', callback);
  } else {
    window.attachEvent('onload', callback);
  }
}


/**
 * Loads the app
 * @param {Function} callback - The function to call
 * @returns {undefined} undefined
 */
domReady(() => {
  const appContainer = document.getElementsByClassName('app-container')[0];

  ReactDOM.render(
    <MediaLabStory
      additionalClassName={'profile'}
      data={storyData}
      logoUrl={'http://bleacherreport.com/br-mag'}
      storyUrl={'http://thelab.bleacherreport.com/tiger-blood/'}
    />,
    appContainer
  );
});



/** WEBPACK FOOTER **
 ** ./assets/js/src/app.js
 **/